module.exports = __webpack_public_path__ + "img/hint-one.27c027dc.jpg";